export const SCORE_COLOR = 'rgb(204, 204, 255, 0.5)';
export const TIME_COLOR = 'rgba(51, 204, 255,0.5)';
